import { resolveComponent as _resolveComponent, createVNode as _createVNode, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, withCtx as _withCtx, withScopeId as _withScopeId, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
import _imports_0 from '../assets/logo.png'

const _withId = /*#__PURE__*/_withScopeId("data-v-0d41ebd2")

_pushScopeId("data-v-0d41ebd2")
const _hoisted_1 = { id: "entire_app__my_tickets" }
const _hoisted_2 = {
  key: 0,
  class: "entire_app_mobile_sidebar_container"
}
const _hoisted_3 = { class: "__mobile_navigation" }
const _hoisted_4 = { class: "logo_container" }
const _hoisted_5 = { class: "menu_toggle" }
const _hoisted_6 = /*#__PURE__*/_createVNode("path", {
  id: "Path_1",
  "data-name": "Path 1",
  d: "M0,0H28V28H0Z",
  fill: "none"
}, null, -1)
const _hoisted_7 = /*#__PURE__*/_createVNode("path", {
  id: "Path_2",
  "data-name": "Path 2",
  d: "M18.889,21.5V24H5.444V21.5ZM25,12.75v2.5H3v-2.5ZM22.556,4V6.5H9.111V4Z",
  transform: "translate(0)",
  fill: "#1d2329"
}, null, -1)
const _hoisted_8 = /*#__PURE__*/_createVNode("div", { class: "logo" }, [
  /*#__PURE__*/_createVNode("img", {
    src: _imports_0,
    alt: "logo"
  })
], -1)
const _hoisted_9 = { class: "settings" }
const _hoisted_10 = /*#__PURE__*/_createVNode("path", {
  id: "Path_3",
  "data-name": "Path 3",
  d: "M0,0H28V28H0Z",
  fill: "none"
}, null, -1)
const _hoisted_11 = /*#__PURE__*/_createVNode("path", {
  id: "Path_4",
  "data-name": "Path 4",
  d: "M2,14a12.19,12.19,0,0,1,.379-3.024A3.6,3.6,0,0,0,5.685,9.171a3.642,3.642,0,0,0-.1-3.784,11.971,11.971,0,0,1,5.2-3.025,3.59,3.59,0,0,0,6.418,0,11.971,11.971,0,0,1,5.2,3.025,3.642,3.642,0,0,0-.1,3.786,3.6,3.6,0,0,0,3.308,1.805,12.239,12.239,0,0,1,0,6.046,3.6,3.6,0,0,0-3.307,1.8,3.642,3.642,0,0,0,.1,3.785,11.971,11.971,0,0,1-5.2,3.025,3.59,3.59,0,0,0-6.418,0,11.971,11.971,0,0,1-5.2-3.025,3.642,3.642,0,0,0,.1-3.786,3.6,3.6,0,0,0-3.308-1.805A12.215,12.215,0,0,1,2,14Zm5.765,3.623a6.065,6.065,0,0,1,.677,4.255A9.594,9.594,0,0,0,10,22.783a5.975,5.975,0,0,1,8,0,9.594,9.594,0,0,0,1.556-.906,6.062,6.062,0,0,1,.677-4.255,6,6,0,0,1,3.324-2.717,9.873,9.873,0,0,0,0-1.811,6,6,0,0,1-3.325-2.717,6.062,6.062,0,0,1-.677-4.255A9.572,9.572,0,0,0,18,5.217a5.973,5.973,0,0,1-8,0,9.573,9.573,0,0,0-1.556.906,6.062,6.062,0,0,1-.677,4.255,6,6,0,0,1-3.324,2.717,9.873,9.873,0,0,0,0,1.811,6,6,0,0,1,3.325,2.717Zm6.235,0A3.623,3.623,0,1,1,17.6,14,3.611,3.611,0,0,1,14,17.623Zm0-2.415A1.208,1.208,0,1,0,12.8,14,1.2,1.2,0,0,0,14,15.208Z",
  transform: "translate(0 0)",
  fill: "#1d2329"
}, null, -1)
const _hoisted_12 = { class: "rest_of_app" }
const _hoisted_13 = { class: "category_advert" }
const _hoisted_14 = /*#__PURE__*/_createVNode("h1", null, "Under Development", -1)
_popScopeId()

export const render = /*#__PURE__*/_withId((_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) => {
  const _component_sidebar = _resolveComponent("sidebar")
  const _component_mobile_sidebar = _resolveComponent("mobile-sidebar")
  const _component_router_link = _resolveComponent("router-link")
  const _component_TransCategSmall = _resolveComponent("TransCategSmall")
  const _component_Advert = _resolveComponent("Advert")

  return (_openBlock(), _createBlock("div", _hoisted_1, [
    _createVNode("div", {
      class: ["entire_app__sidebar_container", {'--sidebar_toggled': _ctx.$store.state.SidebarToggle.sidebar_toggled}]
    }, [
      _createVNode(_component_sidebar)
    ], 2),
    (_ctx.$store.state.Customizations.mobile_siderbar_toggled)
      ? (_openBlock(), _createBlock("div", _hoisted_2, [
          _createVNode(_component_mobile_sidebar)
        ]))
      : _createCommentVNode("", true),
    _createVNode("div", _hoisted_3, [
      _createVNode("div", _hoisted_4, [
        _createVNode("div", _hoisted_5, [
          (_openBlock(), _createBlock("svg", {
            id: "menu",
            onClick: _cache[1] || (_cache[1] = ($event: any) => (_ctx.$store.commit('Customizations/togglemobilesidebar'))),
            xmlns: "http://www.w3.org/2000/svg",
            width: "20",
            height: "20",
            viewBox: "0 0 28 28"
          }, [
            _hoisted_6,
            _hoisted_7
          ]))
        ]),
        _hoisted_8,
        _createVNode("div", _hoisted_9, [
          _createVNode(_component_router_link, { to: "/profile" }, {
            default: _withId(() => [
              (_openBlock(), _createBlock("svg", {
                onClick: _cache[2] || (_cache[2] = ($event: any) => (_ctx.$store.commit('Customizations/togglemobilesidebartofalse'))),
                id: "settings",
                xmlns: "http://www.w3.org/2000/svg",
                width: "20",
                height: "20",
                viewBox: "0 0 28 28"
              }, [
                _hoisted_10,
                _hoisted_11
              ]))
            ]),
            _: 1
          })
        ])
      ])
    ]),
    _createVNode("div", {
      class: ["entire_app__page_content", {'--sidebar_toggled_expd_body': _ctx.$store.state.SidebarToggle.sidebar_toggled}]
    }, [
      _createVNode("div", _hoisted_12, [
        _createVNode("div", _hoisted_13, [
          _createVNode(_component_TransCategSmall),
          _createVNode(_component_Advert)
        ]),
        _hoisted_14
      ])
    ], 2)
  ]))
})